<template>
  <svg
    width="288"
    height="253"
    viewBox="0 0 288 253"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M146.5 74.0294C146.516 73.2011 145.858 72.5165 145.029 72.5003C144.201 72.484 143.517 73.1423 143.5 73.9706L146.5 74.0294ZM143.419 100.54C143.993 101.137 144.943 101.155 145.54 100.581L155.271 91.2243C155.868 90.6501 155.887 89.7005 155.312 89.1034C154.738 88.5062 153.789 88.4876 153.192 89.0618L144.542 97.3791L136.224 88.7291C135.65 88.1319 134.701 88.1133 134.103 88.6875C133.506 89.2617 133.488 90.2113 134.062 90.8084L143.419 100.54ZM143.5 73.9706L143 99.4706L146 99.5294L146.5 74.0294L143.5 73.9706Z"
      fill="#B1BEFF"
    />
    <g filter="url(#filter0_d_12289_7292)">
      <rect
        x="65"
        y="111"
        width="159"
        height="110.327"
        rx="3"
        fill="#3E3F46"
      />
      <rect
        x="126.654"
        y="221.326"
        width="37.3163"
        height="24.3367"
        fill="#EFF0F3"
      />
      <rect
        x="126.653"
        y="244.041"
        width="37.3163"
        height="1.62245"
        fill="#D7D8DB"
      />
      <rect
        x="68.2449"
        y="114.245"
        width="152.51"
        height="87.6122"
        fill="white"
      />
    </g>
    <path
      d="M97.6313 136.664V131.424H98.2873V136.664H97.6313ZM96.3113 133.68C96.3113 134.72 95.4953 135.456 94.4313 135.456C93.3673 135.456 92.5673 134.72 92.5673 133.68C92.5673 132.648 93.3673 131.92 94.4313 131.92C95.4953 131.92 96.3113 132.648 96.3113 133.68ZM93.2073 133.68C93.2073 134.392 93.7273 134.888 94.4313 134.888C95.1433 134.888 95.6713 134.392 95.6713 133.68C95.6713 132.984 95.1433 132.488 94.4313 132.488C93.7273 132.488 93.2073 132.984 93.2073 133.68ZM98.5033 138.432H93.6713V136.128H94.3273V137.896H98.5033V138.432ZM99.9667 133.872C101.255 133.744 102.383 133.104 102.423 132.312H100.199V131.784H105.503V132.312H103.271C103.295 133.104 104.471 133.744 105.727 133.872L105.495 134.392C104.319 134.24 103.231 133.736 102.847 132.944C102.447 133.728 101.367 134.24 100.199 134.392L99.9667 133.872ZM106.087 135.36H99.5987V134.832H106.087V135.36ZM102.839 135.984C104.367 135.984 105.295 136.448 105.295 137.28C105.295 138.12 104.367 138.584 102.839 138.584C101.303 138.584 100.383 138.12 100.383 137.28C100.383 136.448 101.303 135.984 102.839 135.984ZM102.839 138.064C103.967 138.064 104.631 137.792 104.631 137.28C104.631 136.768 103.967 136.496 102.839 136.496C101.711 136.496 101.047 136.768 101.047 137.28C101.047 137.792 101.711 138.064 102.839 138.064ZM111.846 133.84C111.854 133.656 111.862 133.48 111.862 133.296V132.648H107.574V132.112H112.134L112.51 132.12V132.792C112.51 133.672 112.502 134.656 112.206 136.128L111.558 136.048C111.694 135.408 111.758 134.864 111.814 134.352L107.478 134.584L107.382 134.024L111.846 133.84ZM113.286 137.616H106.798V137.08H109.326V135.216H109.982V137.08H113.286V137.616ZM114.821 135.392V132.072H119.677V132.616H115.469V134.856H119.749V135.392H114.821ZM120.501 137.624H113.989V137.08H120.501V137.624ZM122.013 132.088V131.624H126.869V133.12H122.677V133.736H126.997V134.208H122.029V132.672H126.221V132.088H122.013ZM127.701 135.248H121.197V134.752H127.701V135.248ZM127.117 138.024V138.496H121.989V136.904H126.245V136.304H121.973V135.832H126.893V137.36H122.637V138.024H127.117ZM135.913 135.272H135.257V131.424H135.913V135.272ZM132.057 131.76C133.145 131.76 133.937 132.424 133.937 133.408C133.937 134.4 133.145 135.064 132.057 135.064C130.977 135.064 130.193 134.4 130.193 133.408C130.193 132.424 130.977 131.76 132.057 131.76ZM132.057 132.304C131.345 132.304 130.833 132.76 130.833 133.408C130.833 134.072 131.345 134.52 132.057 134.52C132.793 134.52 133.297 134.08 133.297 133.408C133.297 132.76 132.785 132.304 132.057 132.304ZM131.937 136.504H135.265V135.624H135.913V138.496H131.289V135.624H131.937V136.504ZM135.265 137.968V137.016H131.937V137.968H135.265ZM143.129 135.832H142.473V134.504H141.073V133.976H142.473V133.016H141.073V132.48H142.473V131.424H143.129V135.832ZM141.081 135.328C140.201 135.48 139.473 135.504 138.041 135.504H137.529V133.376H139.961V132.384H137.505V131.848H140.601V133.88H138.169V134.968C139.497 134.968 140.193 134.928 141.017 134.8L141.081 135.328ZM143.129 136.216V138.6H142.473V136.752H138.329V136.216H143.129ZM149.952 134.92V138.592H149.296V131.424H149.952V134.368H151.128V134.92H149.952ZM148.616 132.568V133.096H144.384V132.568H146.192V131.504H146.848V132.568H148.616ZM146.528 133.688C147.552 133.688 148.28 134.384 148.28 135.344C148.28 136.328 147.552 136.992 146.528 136.992C145.52 136.992 144.792 136.328 144.792 135.344C144.792 134.384 145.52 133.688 146.528 133.688ZM146.528 136.448C147.192 136.448 147.656 135.984 147.656 135.344C147.656 134.704 147.192 134.232 146.528 134.232C145.88 134.232 145.408 134.704 145.408 135.344C145.408 135.984 145.88 136.448 146.528 136.448ZM151.951 135.392V132.048H155.223V132.68H156.871V131.424H157.535V136.656H156.871V134.752H155.223V135.392H151.951ZM152.599 132.568V134.872H154.583V132.568H152.599ZM155.223 134.216H156.871V133.216H155.223V134.216ZM157.703 138.432H152.919V136.192H153.575V137.896H157.703V138.432ZM161.228 132.312V131.784H166.116V132.392C166.116 132.968 166.116 133.552 165.916 134.288L165.276 134.216C165.468 133.48 165.468 132.944 165.468 132.392V132.312H161.228ZM166.924 135.296H160.468V134.76H163.116V133.384H163.772V134.76H166.924V135.296ZM163.668 135.952C165.196 135.952 166.172 136.44 166.172 137.272C166.172 138.08 165.196 138.584 163.668 138.584C162.14 138.584 161.172 138.08 161.172 137.272C161.172 136.44 162.14 135.952 163.668 135.952ZM163.668 138.072C164.796 138.072 165.516 137.784 165.516 137.272C165.516 136.76 164.796 136.456 163.668 136.456C162.548 136.456 161.828 136.76 161.828 137.272C161.828 137.776 162.548 138.072 163.668 138.072ZM174.147 135.488H167.651V134.96H170.571V134.128H168.467V131.744H173.339V132.272H169.123V133.6H173.387V134.128H171.227V134.96H174.147V135.488ZM170.899 136C172.419 136 173.347 136.464 173.347 137.296C173.347 138.128 172.419 138.592 170.899 138.592C169.363 138.592 168.435 138.128 168.435 137.296C168.435 136.464 169.363 136 170.899 136ZM170.899 138.08C172.027 138.08 172.683 137.808 172.683 137.296C172.683 136.784 172.027 136.512 170.899 136.512C169.739 136.512 169.099 136.784 169.099 137.296C169.099 137.808 169.739 138.08 170.899 138.08ZM180.083 136.664V131.424H180.739V136.664H180.083ZM178.763 133.68C178.763 134.72 177.947 135.456 176.883 135.456C175.819 135.456 175.019 134.72 175.019 133.68C175.019 132.648 175.819 131.92 176.883 131.92C177.947 131.92 178.763 132.648 178.763 133.68ZM175.659 133.68C175.659 134.392 176.179 134.888 176.883 134.888C177.595 134.888 178.123 134.392 178.123 133.68C178.123 132.984 177.595 132.488 176.883 132.488C176.179 132.488 175.659 132.984 175.659 133.68ZM180.955 138.432H176.123V136.128H176.779V137.896H180.955V138.432ZM182.418 133.872C183.706 133.744 184.834 133.104 184.874 132.312H182.65V131.784H187.954V132.312H185.722C185.746 133.104 186.922 133.744 188.178 133.872L187.946 134.392C186.77 134.24 185.682 133.736 185.298 132.944C184.898 133.728 183.818 134.24 182.65 134.392L182.418 133.872ZM188.538 135.36H182.05V134.832H188.538V135.36ZM185.29 135.984C186.818 135.984 187.746 136.448 187.746 137.28C187.746 138.12 186.818 138.584 185.29 138.584C183.754 138.584 182.834 138.12 182.834 137.28C182.834 136.448 183.754 135.984 185.29 135.984ZM185.29 138.064C186.418 138.064 187.082 137.792 187.082 137.28C187.082 136.768 186.418 136.496 185.29 136.496C184.162 136.496 183.498 136.768 183.498 137.28C183.498 137.792 184.162 138.064 185.29 138.064ZM195.161 138.6H194.505V134.384H192.841V133.848H194.505V131.416H195.161V138.6ZM191.761 133.32C191.761 134.616 192.577 135.936 193.617 136.424L193.233 136.944C192.433 136.536 191.761 135.672 191.433 134.672C191.113 135.736 190.457 136.648 189.649 137.072L189.249 136.552C190.289 136.04 191.105 134.64 191.105 133.32V132.032H191.761V133.32ZM114.706 144.144V141.704H119.578V142.232H115.362V143.616H119.626V144.144H114.706ZM120.386 145.376H113.89V144.832H120.386V145.376ZM117.13 145.992C118.658 145.992 119.586 146.456 119.586 147.288C119.586 148.12 118.658 148.584 117.13 148.584C115.602 148.584 114.674 148.12 114.674 147.288C114.674 146.456 115.602 145.992 117.13 145.992ZM117.13 148.072C118.258 148.072 118.922 147.8 118.922 147.288C118.922 146.776 118.258 146.504 117.13 146.504C116.002 146.504 115.338 146.776 115.338 147.288C115.338 147.8 116.002 148.072 117.13 148.072ZM127.593 145.896H121.081V145.36H124.009V144.608H121.921V142.856H126.113V142.112H121.905V141.6H126.761V143.344H122.569V144.096H126.913V144.608H124.673V145.36H127.593V145.896ZM126.801 146.448V148.528H126.145V146.984H121.809V146.448H126.801ZM131.529 144.024C129.953 144.024 129.009 143.592 129.009 142.784C129.009 141.976 129.953 141.536 131.529 141.536C133.105 141.536 134.049 141.976 134.049 142.784C134.049 143.592 133.105 144.024 131.529 144.024ZM131.529 142.032C130.337 142.032 129.681 142.304 129.681 142.784C129.681 143.264 130.337 143.536 131.529 143.536C132.721 143.536 133.377 143.264 133.377 142.784C133.377 142.304 132.721 142.032 131.529 142.032ZM134.777 145.04H128.281V144.512H134.777V145.04ZM134.161 148V148.512H129.089V146.792H133.297V146.152H129.065V145.656H133.945V147.272H129.729V148H134.161ZM142.989 148.608H142.333V141.416H142.989V148.608ZM139.661 143.328C139.661 144.64 140.525 145.968 141.581 146.44L141.189 146.968C140.357 146.56 139.685 145.728 139.341 144.696C139.013 145.792 138.325 146.656 137.485 147.104L137.085 146.568C138.133 146.056 139.013 144.704 139.013 143.328V142.04H139.661V143.328ZM149.885 143.848V145.744H149.229V141.424H149.885V143.304H150.949V143.848H149.885ZM148.149 145.44C147.349 145.16 146.733 144.576 146.421 143.84C146.109 144.64 145.469 145.272 144.629 145.584L144.285 145.064C145.373 144.68 146.085 143.768 146.085 142.736V142.448H144.477V141.92H148.325V142.448H146.741V142.728C146.741 143.68 147.429 144.56 148.485 144.928L148.149 145.44ZM149.885 146.128V148.6H149.229V146.656H145.213V146.128H149.885ZM151.54 142.68V142.152H153.324V141.344H153.98V142.152H155.772V142.68H151.54ZM157.084 143.792V145.584H156.428V141.416H157.084V143.24H158.148V143.792H157.084ZM155.372 144.272C155.372 145.04 154.676 145.528 153.652 145.528C152.628 145.528 151.94 145.04 151.94 144.272C151.94 143.512 152.628 143.024 153.652 143.024C154.676 143.024 155.372 143.512 155.372 144.272ZM152.564 144.272C152.564 144.752 152.98 145.032 153.652 145.032C154.324 145.032 154.748 144.752 154.748 144.272C154.748 143.792 154.324 143.512 153.652 143.512C152.98 143.512 152.564 143.792 152.564 144.272ZM157.084 145.904V148.496H152.572V145.904H153.22V146.664H156.436V145.904H157.084ZM153.22 147.176V147.968H156.436V147.176H153.22ZM164.595 148.584H163.939V141.416H164.595V148.584ZM159.819 146.176C160.915 146.176 162.011 146.088 163.203 145.84L163.275 146.4C162.019 146.656 160.907 146.736 159.755 146.736H159.163V142.112H159.819V146.176ZM171.435 144.792V148.608H170.779V141.416H171.435V144.248H172.619V144.792H171.435ZM166.875 146.256C168.155 146.256 169.075 146.208 170.107 146.016L170.179 146.56C169.091 146.776 168.131 146.816 166.787 146.816H166.219V142.104H169.555V142.648H166.875V146.256ZM173.754 147.36V148.112H173.026V147.36H173.754Z"
      fill="#8E9098"
    />
    <rect
      x="147"
      y="156"
      width="45"
      height="25"
      fill="#3F75E0"
    />
    <path
      d="M160.71 165.21H165.86V164.59H163.7V163.71H162.88V164.59H160.71V165.21ZM167.48 167.17H168.8V166.49H167.48V163.78H166.66V169.79H167.48V167.17ZM166.19 169.18L166.13 168.59C165.73 168.65 165.33 168.697 164.93 168.73C164.53 168.763 164.12 168.79 163.7 168.81V168.19C164.22 168.137 164.63 167.997 164.93 167.77C165.23 167.537 165.38 167.237 165.38 166.87C165.38 166.657 165.33 166.47 165.23 166.31C165.13 166.143 164.987 166.003 164.8 165.89C164.62 165.777 164.4 165.69 164.14 165.63C163.887 165.57 163.603 165.54 163.29 165.54C162.65 165.54 162.14 165.657 161.76 165.89C161.38 166.123 161.19 166.45 161.19 166.87C161.19 167.25 161.34 167.553 161.64 167.78C161.947 168 162.36 168.137 162.88 168.19V168.84C162.44 168.853 162.02 168.863 161.62 168.87C161.227 168.87 160.85 168.87 160.49 168.87L160.58 169.53C160.973 169.53 161.397 169.53 161.85 169.53C162.303 169.523 162.77 169.51 163.25 169.49C163.737 169.463 164.227 169.427 164.72 169.38C165.22 169.333 165.71 169.267 166.19 169.18ZM161.97 166.87C161.97 166.637 162.087 166.453 162.32 166.32C162.56 166.18 162.883 166.11 163.29 166.11C163.69 166.11 164.007 166.18 164.24 166.32C164.48 166.453 164.6 166.637 164.6 166.87C164.6 167.103 164.48 167.29 164.24 167.43C164.007 167.57 163.69 167.64 163.29 167.64C162.883 167.64 162.56 167.57 162.32 167.43C162.087 167.29 161.97 167.103 161.97 166.87ZM167.48 170.24H161.58V170.89H166.66V172.74H167.48V170.24ZM176.069 170.33H176.889V163.78H176.069V170.33ZM174.419 166.6C174.419 166.28 174.359 165.987 174.239 165.72C174.119 165.447 173.953 165.213 173.739 165.02C173.533 164.82 173.286 164.667 172.999 164.56C172.713 164.453 172.403 164.4 172.069 164.4C171.736 164.4 171.426 164.453 171.139 164.56C170.859 164.667 170.613 164.82 170.399 165.02C170.193 165.213 170.029 165.447 169.909 165.72C169.796 165.987 169.739 166.28 169.739 166.6C169.739 166.927 169.796 167.227 169.909 167.5C170.029 167.767 170.193 168 170.399 168.2C170.613 168.393 170.859 168.547 171.139 168.66C171.426 168.767 171.736 168.82 172.069 168.82C172.403 168.82 172.713 168.767 172.999 168.66C173.286 168.547 173.533 168.393 173.739 168.2C173.953 168 174.119 167.767 174.239 167.5C174.359 167.227 174.419 166.927 174.419 166.6ZM170.539 166.6C170.539 166.38 170.576 166.18 170.649 166C170.729 165.82 170.836 165.663 170.969 165.53C171.109 165.397 171.273 165.293 171.459 165.22C171.646 165.147 171.849 165.11 172.069 165.11C172.289 165.11 172.493 165.147 172.679 165.22C172.873 165.293 173.039 165.397 173.179 165.53C173.319 165.663 173.426 165.82 173.499 166C173.579 166.18 173.619 166.38 173.619 166.6C173.619 166.82 173.579 167.023 173.499 167.21C173.426 167.397 173.319 167.557 173.179 167.69C173.039 167.823 172.873 167.927 172.679 168C172.493 168.073 172.289 168.11 172.069 168.11C171.849 168.11 171.646 168.073 171.459 168C171.273 167.927 171.109 167.823 170.969 167.69C170.836 167.557 170.729 167.397 170.649 167.21C170.576 167.023 170.539 166.82 170.539 166.6ZM177.159 172.54V171.87H171.939V169.66H171.119V172.54H177.159Z"
      fill="white"
    />
    <rect
      x="89.5"
      y="156.5"
      width="57"
      height="24"
      fill="#EFF0F3"
      stroke="#D7D8DB"
    />
    <path
      d="M100.114 168.074L98.98 169.946L99.772 170.522L101.194 168.812L102.616 170.522L103.408 169.946L102.256 168.074L104.218 167.264L103.912 166.346L101.86 166.832L101.68 164.672H100.708L100.528 166.85L98.476 166.346L98.152 167.264L100.114 168.074ZM108.156 168.074L107.022 169.946L107.814 170.522L109.236 168.812L110.658 170.522L111.45 169.946L110.298 168.074L112.26 167.264L111.954 166.346L109.902 166.832L109.722 164.672H108.75L108.57 166.85L106.518 166.346L106.194 167.264L108.156 168.074ZM116.199 168.074L115.065 169.946L115.857 170.522L117.279 168.812L118.701 170.522L119.493 169.946L118.341 168.074L120.303 167.264L119.997 166.346L117.945 166.832L117.765 164.672H116.793L116.613 166.85L114.561 166.346L114.237 167.264L116.199 168.074ZM124.241 168.074L123.107 169.946L123.899 170.522L125.321 168.812L126.743 170.522L127.535 169.946L126.383 168.074L128.345 167.264L128.039 166.346L125.987 166.832L125.807 164.672H124.835L124.655 166.85L122.603 166.346L122.279 167.264L124.241 168.074ZM132.283 168.074L131.149 169.946L131.941 170.522L133.363 168.812L134.785 170.522L135.577 169.946L134.425 168.074L136.387 167.264L136.081 166.346L134.029 166.832L133.849 164.672H132.877L132.697 166.85L130.645 166.346L130.321 167.264L132.283 168.074Z"
      fill="#8E9098"
    />
    <g filter="url(#filter1_d_12289_7292)">
      <path
        d="M65 206H224V219.224C224 220.881 222.657 222.224 221 222.224H68C66.3431 222.224 65 220.881 65 219.224V206Z"
        fill="#EFF0F3"
      />
    </g>
    <g filter="url(#filter2_d_12289_7292)">
      <rect
        x="58.5"
        y="14.5"
        width="39"
        height="49"
        rx="7.5"
        fill="white"
        stroke="#7B90FF"
      />
      <rect
        x="14.5"
        y="14.5"
        width="39"
        height="49"
        rx="7.5"
        fill="white"
        stroke="#7B90FF"
      />
      <path
        d="M32.536 41.96C31.744 35.696 36.04 36.416 36.04 33.296C36.04 32.048 35.464 31.088 34.12 31.088C32.776 31.088 31.84 32 31.72 33.92H28.72C28.984 29.672 31.84 28.304 34.216 28.424C37.048 28.544 39.232 30.176 39.232 33.056C39.232 38.264 34.528 36.512 35.248 41.96H32.536ZM32.128 47.336V43.928H35.632V47.336H32.128Z"
        fill="#5061FA"
      />
      <path
        d="M76.536 41.96C75.744 35.696 80.04 36.416 80.04 33.296C80.04 32.048 79.464 31.088 78.12 31.088C76.776 31.088 75.84 32 75.72 33.92H72.72C72.984 29.672 75.84 28.304 78.216 28.424C81.048 28.544 83.232 30.176 83.232 33.056C83.232 38.264 78.528 36.512 79.248 41.96H76.536ZM76.128 47.336V43.928H79.632V47.336H76.128Z"
        fill="#5061FA"
      />
      <rect
        x="146.5"
        y="14.5"
        width="39"
        height="49"
        rx="7.5"
        fill="white"
        stroke="#7B90FF"
      />
      <rect
        x="102.5"
        y="14.5"
        width="39"
        height="49"
        rx="7.5"
        fill="white"
        stroke="#7B90FF"
      />
      <rect
        x="190.5"
        y="14.5"
        width="39"
        height="49"
        rx="7.5"
        fill="white"
        stroke="#7B90FF"
      />
      <rect
        x="234.5"
        y="14.5"
        width="39"
        height="49"
        rx="7.5"
        fill="white"
        stroke="#7B90FF"
      />
      <path
        d="M120.536 41.96C119.744 35.696 124.04 36.416 124.04 33.296C124.04 32.048 123.464 31.088 122.12 31.088C120.776 31.088 119.84 32 119.72 33.92H116.72C116.984 29.672 119.84 28.304 122.216 28.424C125.048 28.544 127.232 30.176 127.232 33.056C127.232 38.264 122.528 36.512 123.248 41.96H120.536ZM120.128 47.336V43.928H123.632V47.336H120.128Z"
        fill="#5061FA"
      />
      <path
        d="M164.536 41.96C163.744 35.696 168.04 36.416 168.04 33.296C168.04 32.048 167.464 31.088 166.12 31.088C164.776 31.088 163.84 32 163.72 33.92H160.72C160.984 29.672 163.84 28.304 166.216 28.424C169.048 28.544 171.232 30.176 171.232 33.056C171.232 38.264 166.528 36.512 167.248 41.96H164.536ZM164.128 47.336V43.928H167.632V47.336H164.128Z"
        fill="#5061FA"
      />
      <path
        d="M208.536 41.96C207.744 35.696 212.04 36.416 212.04 33.296C212.04 32.048 211.464 31.088 210.12 31.088C208.776 31.088 207.84 32 207.72 33.92H204.72C204.984 29.672 207.84 28.304 210.216 28.424C213.048 28.544 215.232 30.176 215.232 33.056C215.232 38.264 210.528 36.512 211.248 41.96H208.536ZM208.128 47.336V43.928H211.632V47.336H208.128Z"
        fill="#5061FA"
      />
      <path
        d="M252.536 41.96C251.744 35.696 256.04 36.416 256.04 33.296C256.04 32.048 255.464 31.088 254.12 31.088C252.776 31.088 251.84 32 251.72 33.92H248.72C248.984 29.672 251.84 28.304 254.216 28.424C257.048 28.544 259.232 30.176 259.232 33.056C259.232 38.264 254.528 36.512 255.248 41.96H252.536ZM252.128 47.336V43.928H255.632V47.336H252.128Z"
        fill="#5061FA"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_12289_7292"
        x="60"
        y="108"
        width="169"
        height="144.663"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2.5" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.4875 0 0 0 0 0.4875 0 0 0 0 0.4875 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_12289_7292"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_12289_7292"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_12289_7292"
        x="53"
        y="199"
        width="183"
        height="40.2246"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="6" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.486275 0 0 0 0 0.486275 0 0 0 0 0.486275 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_12289_7292"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_12289_7292"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_12289_7292"
        x="0"
        y="0"
        width="288"
        height="78"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="7" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.317647 0 0 0 0 0.384314 0 0 0 0 0.980392 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_12289_7292"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_12289_7292"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>
